import { Box, styled } from "@mui/material";

const BLOG_MARKDOWN_CONTENT_PREFIX = "BlogMarkdownContent";

export const blogMarkdownContentClasses = {
  root: `${BLOG_MARKDOWN_CONTENT_PREFIX}-root`,
};

export const StyledBlogMarkdownContent = styled(Box)(({ theme }) => ({
  [`&.${blogMarkdownContentClasses.root}`]: {
    marginBottom: "48px",
    color: "#011E3F",
    fontSize: "18px",
    lineHeight: "30px",
    opacity: 0.9,
    overflow: "hidden", // Allow floating images
    [`& p`]: {
      marginBottom: "16px",
    },
    [`& .blog-clear`]: {
      clear: "both",
    },
    [`& strong`]: {
      fontWeight: "bold",
    },
    [`& em`]: {
      fontStyle: "italic",
    },
    [`& h3`]: {
      color: "#0F2F4B",
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "15px",
      marginTop: "24px",
    },
    [`& h4`]: {
      color: "#0F2F4B",
      fontSize: "22px",
      fontWeight: "bold",
      marginBottom: "15px",
      marginTop: "24px",
    },
    [`& h5`]: {
      color: "#0F2F4B",
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "15px",
      marginTop: "24px",
    },
    [`& a`]: {
      color: "#4A90E2",
      textDecoration: "underline",
      "&:hover": {
        color: "#6BA3E8",
      },
    },
    [`& blockquote`]: {
      borderLeft: "4px solid #4A90E2",
      paddingLeft: "20px",
      margin: "20px auto",
      width: "80%",
      fontStyle: "italic",
      opacity: 0.8,
      [`@media (max-width: 768px)`]: {
        width: "100%",
      },
    },
    [`& ul`]: {
      margin: "16px 0",
      paddingLeft: "24px",
    },
    [`& li`]: {
      marginBottom: "8px",
    },
    [`& img`]: {
      maxWidth: "100%",
      height: "auto",
      borderRadius: "8px",
      margin: "10px 0 10px",
      display: "block",
      [`&[style*="float"]`]: {
        display: "inline-block",
        marginTop: "0",
        marginBottom: "16px",
      },
      [`@media (max-width: 768px)`]: {
        width: "100% !important",
        maxWidth: "100% !important",
      },
    },
    [`& .blog-image-container`]: {
      [`@media (max-width: 768px)`]: {
        float: "none !important",
        width: "100% !important",
        marginLeft: "0 !important",
        marginRight: "0 !important",
        [`& img`]: {
          width: "100% !important",
        },
      },
    },
  },
}));

